import React, { useEffect, useState } from 'react';
import { history, useParams } from 'umi';
import Loading from '@/pages/dashboard/components/Loadings';
import { IStudioInfo } from '@/pages/home/pages/studio/type';
import { getStudioInfo } from '@/pages/home/services/studio';
import { StudioFullscreenProvider } from '../components/StudioFullscreen/context';

import './index.scss';

interface IProps {
  children?: React.ReactNode;
}
const StudioLayout = (props: IProps) => {
  const { studioId } = useParams() || {} as any;
  const [studioInfo, setOriginStudioInfo] = useState<IStudioInfo>({
    data: {
      company: {
        area: '',
        name: '',
        img_url: '',
        national_flag: '',
        location_city: '',
        region: '',
        location_country: '',
        continent: '',
        genre: '',
        game_sum: 0
      },
      studio_info: {
        studio_code: '',
        name_cn: '',
        name_en: '',
        title_cn: '',
        title_en: '',
        company_id: '',
        icon_url: '',
        background_url: '',
        element_url: '',
        sort: 0,
        status: 0,
        description: '',
        focus_genre: ''
      },
      game_list: [],
      haveHome: false,
      haveSidebarGameHub: false,
    }, loading: true, errMsg: ''
  });

  // 设置studio工作室数据
  const setStudioInfo = (val = {}) => {
    setOriginStudioInfo({
      ...studioInfo,
      ...val,
    });
  };

  // 获取studio工作室数据
  useEffect(() => {
    setStudioInfo({ loading: true });
    getStudioInfo({ studio_code: studioId })
      .then((res) => {
        setStudioInfo({ data: res, loading: false, errMsg: '' });
      })
      .catch((error) => {
        setStudioInfo({
          data: {},
          loading: false,
          errorMsg: error?.msg,
        });
        history.replace('/home'); // 无studio权限则返回home页
      });
  }, [studioId]);

  return (
    <>
      {studioInfo?.loading ? (
        <Loading />
      ) : (
        <StudioFullscreenProvider>
          <div className="dbh-studio-outter">
            <div className="dbh-studio">
              {
                // 保证是jsx数组，而不是其他类型数组
                React.Children.map(props.children, (child: any) => React.cloneElement(
                  child,
                  {
                    studioInfo,
                  }
                ))
              }
            </div>
          </div>
        </StudioFullscreenProvider>
      )}
    </>
  );
};

export default StudioLayout;
